import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Input, Alert, Nav, NavItem, NavLink, TabContent, TabPane,
  FormGroup, Label
} from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  getCarriers,
  createShipment as seCreateShipment,
  trackShipment,
  getShipmentLabel,
  cancelShipment as seCancelShipment,
} from "../../../services/shipEntegraService";
import {
  getCargoIntegrations,
  getWarehouses,
  createShipment as keCreateShipment,
  getShipment as keGetShipment,
  cancelShipment as keCancelShipment,
  printLabel as kePrintLabel,
} from "../../../services/kargoEntegratorService";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const DURUM_RENKLERI = {
  "Beklemede": "warning",
  "Hazırlanıyor": "info",
  "Kargoya Verildi": "primary",
  "Teslim Edildi": "success",
  "İade": "danger",
};

const BOSTA_DURUM_MAP = {
  "CREATED": "Kargo Oluşturuldu",
  "PICKED_UP": "Teslim Alındı",
  "IN_TRANSIT": "Aktarma Merkezinde",
  "OUT_FOR_DELIVERY": "Dağıtımda",
  "DELIVERED": "Teslim Edildi",
  "FAILED_DELIVERY": "Teslim Edilemedi",
  "RETURNED": "İade",
};

const DEFAULT_SE_FORM = {
  carrierId: "",
  receiverName: "",
  receiverPhone: "",
  receiverAddress: "",
  receiverCity: "",
  receiverDistrict: "",
  receiverPostalCode: "",
  weight: "1",
  desi: "1",
  description: "",
  paymentType: "0",
};

const DEFAULT_KE_FORM = {
  cargo_integration_id: "",
  warehouse_id: "",
  name: "",
  surname: "",
  phone: "",
  email: "",
  country: "TÜRKİYE",
  postcode: "",
  city: "",
  district: "",
  address: "",
  payment_type: "cash_money",
  package_type: "box",
  payor_type: "sender",
  is_pay_at_door: false,
  desi: "1",
  kg: "1",
  note: "",
};

// KargoEntegratör referans ID'si "KE-" prefix'i ile başlar
const KE_PREFIX = "KE-";
const isKEShipment = (referansId) =>
  referansId && String(referansId).startsWith(KE_PREFIX);
const keId = (referansId) => String(referansId).replace(KE_PREFIX, "");

const TeslimatYonetimi = () => {
  document.title = "Teslimat Yönetimi | HarmanaGEL";

  const [teslimalar, setTeslimalar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [activeTab, setActiveTab] = useState("tumu");

  // Düzenle modal
  const [editModal, setEditModal] = useState(false);
  const [selectedTeslimat, setSelectedTeslimat] = useState(null);
  const [formData, setFormData] = useState({
    TESLIMAT_DURUMU: "", KARGO_FIRMasi: "", KARGO_TAKIP_NO: "", KARGO_REFERANS_ID: ""
  });

  // Kargo oluştur modal
  const [createModal, setCreateModal] = useState(false);
  const [provider, setProvider] = useState("ke"); // "ke" | "se"

  // ShipEntegra state
  const [carriers, setCarriers] = useState([]);
  const [carriersLoading, setCarriersLoading] = useState(false);
  const [seForm, setSeForm] = useState(DEFAULT_SE_FORM);

  // KargoEntegratör state
  const [keIntegrations, setKeIntegrations] = useState([]);
  const [keWarehouses, setKeWarehouses] = useState([]);
  const [keLoading, setKeLoading] = useState(false);
  const [keForm, setKeForm] = useState(DEFAULT_KE_FORM);

  const [shipmentLoading, setShipmentLoading] = useState(false);

  // Takip modal
  const [trackModal, setTrackModal] = useState(false);
  const [trackData, setTrackData] = useState(null);
  const [trackLoading, setTrackLoading] = useState(false);

  const fetchTeslimalar = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/SIPARIS_TESLIMATLARI?$top=500&$orderby=ID desc&$expand=SIPARIS($expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO);$select=ID,KULLANICI_ID,TOPLAM_TUTAR,SIPARIS_NOTU,KULLANICILAR)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setTeslimalar(result.value);
    } catch {
      setError("Teslimalar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const fetchSECarriers = useCallback(async () => {
    setCarriersLoading(true);
    try {
      const list = await getCarriers();
      setCarriers(list);
    } catch (err) {
      setError("ShipEntegra kargo firmaları yüklenemedi: " + err.message);
    } finally {
      setCarriersLoading(false);
    }
  }, []);

  const fetchKEData = useCallback(async () => {
    setKeLoading(true);
    try {
      const [integrations, warehouses] = await Promise.all([
        getCargoIntegrations(),
        getWarehouses(),
      ]);
      setKeIntegrations(integrations);
      setKeWarehouses(warehouses);
    } catch (err) {
      setError("KargoEntegratör verileri yüklenemedi: " + err.message);
    } finally {
      setKeLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeslimalar();
  }, [fetchTeslimalar]);

  const showSuccess = (msg) => {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(""), 3500);
  };

  // ---------- Düzenleme ----------
  const handleEdit = (teslimat) => {
    setSelectedTeslimat(teslimat);
    setFormData({
      TESLIMAT_DURUMU: teslimat.TESLIMAT_DURUMU || "Beklemede",
      KARGO_FIRMasi: teslimat.KARGO_FIRMasi || "",
      KARGO_TAKIP_NO: teslimat.KARGO_TAKIP_NO || "",
      KARGO_REFERANS_ID: teslimat.KARGO_REFERANS_ID || "",
    });
    setEditModal(true);
  };

  const handleSave = async () => {
    try {
      await fetch(`${BASE_URL}/SIPARIS_TESLIMATLARI(${selectedTeslimat.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify(formData),
      });
      showSuccess("Teslimat bilgileri güncellendi.");
      setEditModal(false);
      fetchTeslimalar();
    } catch {
      setError("Güncelleme sırasında hata oluştu.");
    }
  };

  // ---------- Kargo Oluştur Modal ----------
  const openCreateModal = (teslimat) => {
    setSelectedTeslimat(teslimat);
    const musteri = teslimat.SIPARIS?.KULLANICILAR;
    const adSoyad = musteri?.AD_SOYAD || "";
    const adParcalari = adSoyad.split(" ");
    const ad = adParcalari.slice(0, -1).join(" ") || adSoyad;
    const soyad = adParcalari.length > 1 ? adParcalari[adParcalari.length - 1] : "";

    setProvider("ke");
    setSeForm({
      ...DEFAULT_SE_FORM,
      receiverName: adSoyad,
      receiverPhone: musteri?.CEP_NO || "",
      description: `Sipariş #${teslimat.SIPARIS_ID}`,
    });
    setKeForm({
      ...DEFAULT_KE_FORM,
      name: ad,
      surname: soyad,
      phone: musteri?.CEP_NO || "",
      note: `Sipariş #${teslimat.SIPARIS_ID}`,
    });
    setCreateModal(true);

    // KE varsayılan; verileri önceden yüklenmemişse yükle
    if (keIntegrations.length === 0 || keWarehouses.length === 0) fetchKEData();
  };

  const handleProviderChange = (newProvider) => {
    setProvider(newProvider);
    if (newProvider === "se" && carriers.length === 0) fetchSECarriers();
    if (newProvider === "ke" && (keIntegrations.length === 0 || keWarehouses.length === 0)) fetchKEData();
  };

  // ---------- Kargo Oluştur ----------
  const handleCreateShipment = async () => {
    setShipmentLoading(true);
    try {
      if (provider === "ke") {
        // KargoEntegratör
        if (!keForm.cargo_integration_id) {
          setError("Lütfen bir kargo firması seçin.");
          setShipmentLoading(false);
          return;
        }
        if (!keForm.warehouse_id) {
          setError("Lütfen bir depo seçin.");
          setShipmentLoading(false);
          return;
        }
        const payload = {
          cargo_integration_id: parseInt(keForm.cargo_integration_id, 10),
          warehouse_id: parseInt(keForm.warehouse_id, 10),
          customer: {
            name: keForm.name,
            surname: keForm.surname,
            phone: keForm.phone,
            email: keForm.email,
            country: keForm.country || "TÜRKİYE",
            postcode: keForm.postcode,
            city: keForm.city,
            district: keForm.district,
            address: keForm.address,
          },
          payment_type: keForm.payment_type,
          package_type: keForm.package_type,
          payor_type: keForm.payor_type,
          is_pay_at_door: keForm.is_pay_at_door,
          desi: parseFloat(keForm.desi) || 1,
          kg: parseFloat(keForm.kg) || 1,
          note: keForm.note,
          platform_id: selectedTeslimat.SIPARIS_ID,
          platform_d_id: selectedTeslimat.SIPARIS_ID,
        };
        const result = await keCreateShipment(payload);

        const firmaAdi =
          keIntegrations.find(
            (i) => String(i.id) === String(keForm.cargo_integration_id)
          )?.name ||
          result.cargo_company?.title ||
          "KargoEntegratör";

        await fetch(`${BASE_URL}/SIPARIS_TESLIMATLARI(${selectedTeslimat.ID})`, {
          method: "PATCH",
          headers: getAuthHeaders(),
          body: JSON.stringify({
            KARGO_FIRMasi: firmaAdi,
            KARGO_TAKIP_NO: result.barcode || result.tracking_number || "",
            KARGO_REFERANS_ID: `${KE_PREFIX}${result.id}`,
            KARGO_TAKIP_LINKI: result.tracking_link || "",
            TESLIMAT_DURUMU: "Kargoya Verildi",
          }),
        });

        showSuccess(
          `Kargo başarıyla oluşturuldu! Barkod: ${result.barcode || "-"}`
        );
      } else {
        // ShipEntegra
        if (!seForm.carrierId) {
          setError("Lütfen bir kargo firması seçin.");
          setShipmentLoading(false);
          return;
        }
        const payload = {
          carrierId: seForm.carrierId,
          receiver: {
            name: seForm.receiverName,
            phone: seForm.receiverPhone,
            address: seForm.receiverAddress,
            city: seForm.receiverCity,
            district: seForm.receiverDistrict,
            postalCode: seForm.receiverPostalCode,
          },
          package: {
            weight: parseFloat(seForm.weight) || 1,
            desi: parseFloat(seForm.desi) || 1,
          },
          description: seForm.description,
          paymentType: parseInt(seForm.paymentType, 10),
          referenceNo: `SIPARIS-${selectedTeslimat.SIPARIS_ID}`,
        };
        const result = await seCreateShipment(payload);

        const kargoFirmaAdi =
          carriers.find(
            (c) => String(c.id || c.Id || c.carrierId) === String(seForm.carrierId)
          )?.name || "ShipEntegra";

        await fetch(`${BASE_URL}/SIPARIS_TESLIMATLARI(${selectedTeslimat.ID})`, {
          method: "PATCH",
          headers: getAuthHeaders(),
          body: JSON.stringify({
            KARGO_FIRMasi: kargoFirmaAdi,
            KARGO_TAKIP_NO:
              result.barcode || result.trackingNumber || result.tracking_number || "",
            KARGO_REFERANS_ID:
              result.id || result.shipmentId || result.referenceNo || "",
            TESLIMAT_DURUMU: "Kargoya Verildi",
          }),
        });

        showSuccess(
          `Kargo başarıyla oluşturuldu! Takip No: ${result.barcode || result.trackingNumber || "-"}`
        );
      }

      setCreateModal(false);
      fetchTeslimalar();
    } catch (err) {
      setError("Kargo oluşturma hatası: " + err.message);
    } finally {
      setShipmentLoading(false);
    }
  };

  // ---------- Takip ----------
  const handleTrack = async (teslimat) => {
    if (!teslimat.KARGO_TAKIP_NO && !teslimat.KARGO_REFERANS_ID) {
      setError("Bu teslimat için takip bilgisi yok.");
      return;
    }
    setSelectedTeslimat(teslimat);
    setTrackData(null);
    setTrackModal(true);
    setTrackLoading(true);
    try {
      if (isKEShipment(teslimat.KARGO_REFERANS_ID)) {
        const data = await keGetShipment(keId(teslimat.KARGO_REFERANS_ID));
        setTrackData({ _source: "ke", ...data });
      } else {
        if (!teslimat.KARGO_TAKIP_NO) {
          setError("Takip numarası bulunamadı.");
          setTrackModal(false);
          return;
        }
        const data = await trackShipment(teslimat.KARGO_TAKIP_NO);
        setTrackData({ _source: "se", ...data });
      }
    } catch (err) {
      setError("Takip bilgisi alınamadı: " + err.message);
      setTrackModal(false);
    } finally {
      setTrackLoading(false);
    }
  };

  // ---------- Etiket ----------
  const handleLabel = async (teslimat) => {
    if (!teslimat.KARGO_REFERANS_ID) {
      setError("Etiket için referans ID bulunamadı.");
      return;
    }
    try {
      if (isKEShipment(teslimat.KARGO_REFERANS_ID)) {
        const blobUrl = await kePrintLabel(keId(teslimat.KARGO_REFERANS_ID));
        const a = document.createElement("a");
        a.href = blobUrl;
        a.target = "_blank";
        a.click();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
      } else {
        const data = await getShipmentLabel(teslimat.KARGO_REFERANS_ID);
        const pdfUrl = data.labelUrl || data.url || data.pdf;
        if (pdfUrl) window.open(pdfUrl, "_blank");
        else setError("Etiket URL'si alınamadı.");
      }
    } catch (err) {
      setError("Etiket alınamadı: " + err.message);
    }
  };

  // ---------- İptal ----------
  const handleCancel = async (teslimat) => {
    if (!teslimat.KARGO_REFERANS_ID) {
      setError("İptal için referans ID bulunamadı.");
      return;
    }
    if (!window.confirm("Kargoyu iptal etmek istediğinizden emin misiniz?")) return;
    try {
      if (isKEShipment(teslimat.KARGO_REFERANS_ID)) {
        await keCancelShipment(keId(teslimat.KARGO_REFERANS_ID));
      } else {
        await seCancelShipment(teslimat.KARGO_REFERANS_ID);
      }
      await fetch(`${BASE_URL}/SIPARIS_TESLIMATLARI(${teslimat.ID})`, {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify({ TESLIMAT_DURUMU: "İade" }),
      });
      showSuccess("Kargo iptali başarılı.");
      fetchTeslimalar();
    } catch (err) {
      setError("İptal hatası: " + err.message);
    }
  };

  // ---------- Filtre ----------
  const filteredTeslimalar = useMemo(() => {
    if (activeTab === "tumu") return teslimalar;
    return teslimalar.filter((t) => t.TESLIMAT_DURUMU === activeTab);
  }, [teslimalar, activeTab]);

  const durumCounts = useMemo(() => {
    const c = {};
    teslimalar.forEach((t) => {
      c[t.TESLIMAT_DURUMU] = (c[t.TESLIMAT_DURUMU] || 0) + 1;
    });
    return c;
  }, [teslimalar]);

  // ---------- Kolonlar ----------
  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "ID",
        enableSorting: true,
        enableColumnFilter: false,
        cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
      },
      {
        header: "Sipariş No",
        accessorKey: "SIPARIS_ID",
        enableSorting: true,
        enableColumnFilter: false,
        cell: (cell) => (
          <span className="text-primary fw-medium">#{cell.getValue()}</span>
        ),
      },
      {
        header: "Müşteri",
        accessorKey: "SIPARIS",
        enableSorting: false,
        enableColumnFilter: false,
        cell: (cell) => {
          const s = cell.getValue();
          return s?.KULLANICILAR?.AD_SOYAD || "-";
        },
      },
      {
        header: "Kargo Firması",
        accessorKey: "KARGO_FIRMasi",
        enableSorting: false,
        enableColumnFilter: false,
        cell: (cell) => cell.getValue() || <span className="text-muted">-</span>,
      },
      {
        header: "Takip No",
        accessorKey: "KARGO_TAKIP_NO",
        enableSorting: false,
        enableColumnFilter: false,
        cell: (cell) =>
          cell.getValue() ? (
            <span className="fw-medium font-monospace">{cell.getValue()}</span>
          ) : (
            <span className="text-muted">-</span>
          ),
      },
      {
        header: "Takip Linki",
        accessorKey: "KARGO_TAKIP_LINKI",
        enableSorting: false,
        enableColumnFilter: false,
        cell: (cell) => {
          const link = cell.getValue();
          return link ? (
            <a href={link} target="_blank" rel="noreferrer" className="btn btn-outline-info btn-sm">
              <i className="bx bx-link-external me-1" />Takip Et
            </a>
          ) : (
            <span className="text-muted">-</span>
          );
        },
      },
      {
        header: "Durum",
        accessorKey: "TESLIMAT_DURUMU",
        enableSorting: true,
        enableColumnFilter: false,
        cell: (cell) => (
          <Badge color={DURUM_RENKLERI[cell.getValue()] || "secondary"}>
            {cell.getValue() || "Bilinmiyor"}
          </Badge>
        ),
      },
      {
        header: "İşlemler",
        enableSorting: false,
        enableColumnFilter: false,
        cell: (cellProps) => {
          const t = cellProps.row.original;
          const hasTracking = !!t.KARGO_TAKIP_NO;
          const hasRef = !!t.KARGO_REFERANS_ID;
          return (
            <div className="d-flex gap-1 flex-wrap">
              <Button
                color="primary"
                size="sm"
                outline
                onClick={() => handleEdit(t)}
                title="Düzenle"
              >
                <i className="bx bx-edit" />
              </Button>
              {!hasTracking && !hasRef ? (
                <Button
                  color="success"
                  size="sm"
                  onClick={() => openCreateModal(t)}
                  title="Kargo Oluştur"
                >
                  <i className="bx bx-package me-1" />
                  Kargo Oluştur
                </Button>
              ) : (
                <>
                  <Button
                    color="info"
                    size="sm"
                    onClick={() => handleTrack(t)}
                    title="Kargo Takip"
                  >
                    <i className="bx bx-map-pin me-1" />
                    Takip
                  </Button>
                  {hasRef && (
                    <>
                      <Button
                        color="secondary"
                        size="sm"
                        outline
                        onClick={() => handleLabel(t)}
                        title="Etiket PDF"
                      >
                        <i className="bx bx-printer" />
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        outline
                        onClick={() => handleCancel(t)}
                        title="İptal Et"
                      >
                        <i className="bx bx-x" />
                      </Button>
                    </>
                  )}
                </>
              )}
            </div>
          );
        },
      },
    ],
    [keIntegrations, carriers]
  );

  const tabItems = [
    { key: "tumu", label: "Tümü", count: teslimalar.length },
    { key: "Beklemede", label: "Beklemede", count: durumCounts["Beklemede"] || 0 },
    { key: "Hazırlanıyor", label: "Hazırlanıyor", count: durumCounts["Hazırlanıyor"] || 0 },
    { key: "Kargoya Verildi", label: "Kargoya Verildi", count: durumCounts["Kargoya Verildi"] || 0 },
    { key: "Teslim Edildi", label: "Teslim Edildi", count: durumCounts["Teslim Edildi"] || 0 },
    { key: "İade", label: "İade", count: durumCounts["İade"] || 0 },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Teslimat Yönetimi" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && (
            <Alert color="danger" toggle={() => setError(null)}>
              {error}
            </Alert>
          )}

          {/* Özet Kartlar */}
          <Row className="mb-3">
            {[
              { label: "Toplam Teslimat", count: teslimalar.length, color: "primary", icon: "bx-package" },
              { label: "Beklemede", count: durumCounts["Beklemede"] || 0, color: "warning", icon: "bx-time" },
              { label: "Kargoya Verildi", count: durumCounts["Kargoya Verildi"] || 0, color: "info", icon: "bx-truck" },
              { label: "Teslim Edildi", count: durumCounts["Teslim Edildi"] || 0, color: "success", icon: "bx-check-circle" },
            ].map((item, idx) => (
              <Col md={3} key={idx}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">{item.label}</p>
                        <h4 className="mb-0">{item.count}</h4>
                      </div>
                      <div
                        className={`avatar-sm align-self-center mini-stat-icon rounded-circle bg-${item.color}`}
                      >
                        <span className="avatar-title">
                          <i className={`bx ${item.icon} font-size-24`} />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="pt-0 pb-0 border-bottom">
                  <Nav tabs className="nav-tabs-custom">
                    {tabItems.map((tab) => (
                      <NavItem key={tab.key}>
                        <NavLink
                          className={classnames({ active: activeTab === tab.key })}
                          onClick={() => setActiveTab(tab.key)}
                          style={{ cursor: "pointer" }}
                        >
                          {tab.label}
                          {tab.count > 0 && (
                            <Badge color="primary" pill className="ms-1">
                              {tab.count}
                            </Badge>
                          )}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                </CardBody>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Sipariş Teslimatları</h4>
                    <div className="d-flex align-items-center gap-2">
                      <Badge color="success" className="px-2 py-1">
                        <i className="bx bxs-package me-1" />
                        KargoEntegratör + ShipEntegra
                      </Badge>
                      <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={fetchTeslimalar}
                        disabled={isLoading}
                      >
                        <i className="bx bx-refresh me-1" />
                        Yenile
                      </Button>
                    </div>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={filteredTeslimalar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Teslimat ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Manuel Düzenle Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader toggle={() => setEditModal(false)}>
          Teslimat Güncelle #{selectedTeslimat?.ID}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Teslimat Durumu</Label>
            <Input
              type="select"
              value={formData.TESLIMAT_DURUMU}
              onChange={(e) =>
                setFormData({ ...formData, TESLIMAT_DURUMU: e.target.value })
              }
            >
              <option value="Beklemede">Beklemede</option>
              <option value="Hazırlanıyor">Hazırlanıyor</option>
              <option value="Kargoya Verildi">Kargoya Verildi</option>
              <option value="Teslim Edildi">Teslim Edildi</option>
              <option value="İade">İade</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Kargo Firması</Label>
            <Input
              value={formData.KARGO_FIRMasi}
              onChange={(e) =>
                setFormData({ ...formData, KARGO_FIRMasi: e.target.value })
              }
              placeholder="Yurtiçi, Aras, PTT..."
            />
          </FormGroup>
          <FormGroup>
            <Label>Kargo Takip No</Label>
            <Input
              value={formData.KARGO_TAKIP_NO}
              onChange={(e) =>
                setFormData({ ...formData, KARGO_TAKIP_NO: e.target.value })
              }
              placeholder="Takip numarası"
            />
          </FormGroup>
          <FormGroup>
            <Label>Referans ID</Label>
            <Input
              value={formData.KARGO_REFERANS_ID}
              onChange={(e) =>
                setFormData({ ...formData, KARGO_REFERANS_ID: e.target.value })
              }
              placeholder="Referans ID"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setEditModal(false)}>
            İptal
          </Button>
          <Button color="primary" onClick={handleSave}>
            Kaydet
          </Button>
        </ModalFooter>
      </Modal>

      {/* Kargo Oluştur Modal */}
      <Modal
        isOpen={createModal}
        toggle={() => setCreateModal(false)}
        size="lg"
        centered
      >
        <ModalHeader toggle={() => setCreateModal(false)}>
          <i className="bx bxs-package me-2 text-success" />
          Kargo Oluştur — Sipariş #{selectedTeslimat?.SIPARIS_ID}
        </ModalHeader>
        <ModalBody>
          {/* Provider Seçimi */}
          <div className="d-flex gap-2 mb-4">
            <Button
              color={provider === "ke" ? "primary" : "outline-secondary"}
              size="sm"
              onClick={() => handleProviderChange("ke")}
              className="d-flex align-items-center gap-1"
            >
              <i className="bx bx-truck" /> KargoEntegratör
              <Badge color="success" className="ms-1">Yurt İçi</Badge>
            </Button>
            <Button
              color={provider === "se" ? "primary" : "outline-secondary"}
              size="sm"
              onClick={() => handleProviderChange("se")}
              className="d-flex align-items-center gap-1"
            >
              <i className="bx bx-globe" /> ShipEntegra
              <Badge color="info" className="ms-1">Yurt Dışı</Badge>
            </Button>
          </div>

          {/* KargoEntegratör Formu */}
          {provider === "ke" && (
            <>
              {keLoading ? (
                <div className="text-center py-3">
                  <Spinner size="sm" /> KargoEntegratör verileri yükleniyor...
                </div>
              ) : (
                <Row>
                  <Col md={6}>
                    <h6 className="mb-3 text-muted">Kargo Ayarları</h6>
                    <FormGroup>
                      <Label>Kargo Firması *</Label>
                      <Input
                        type="select"
                        value={keForm.cargo_integration_id}
                        onChange={(e) =>
                          setKeForm({ ...keForm, cargo_integration_id: e.target.value })
                        }
                      >
                        <option value="">-- Kargo Seçin --</option>
                        {keIntegrations.map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.name || i.cargo_company?.title || `Entegrasyon #${i.id}`}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>Depo *</Label>
                      <Input
                        type="select"
                        value={keForm.warehouse_id}
                        onChange={(e) =>
                          setKeForm({ ...keForm, warehouse_id: e.target.value })
                        }
                      >
                        <option value="">-- Depo Seçin --</option>
                        {keWarehouses.map((w) => (
                          <option key={w.id} value={w.id}>
                            {w.name}
                            {w.is_default ? " (Varsayılan)" : ""}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>Ödeme Tipi</Label>
                      <Input
                        type="select"
                        value={keForm.payment_type}
                        onChange={(e) =>
                          setKeForm({ ...keForm, payment_type: e.target.value })
                        }
                      >
                        <option value="cash_money">Nakit</option>
                        <option value="credit_card">Kredi Kartı</option>
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>Ödeyen Taraf</Label>
                      <Input
                        type="select"
                        value={keForm.payor_type}
                        onChange={(e) =>
                          setKeForm({ ...keForm, payor_type: e.target.value })
                        }
                      >
                        <option value="sender">Gönderici Öder</option>
                        <option value="reciver">Alıcı Öder</option>
                      </Input>
                    </FormGroup>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Ağırlık (kg)</Label>
                          <Input
                            type="number"
                            min="0.1"
                            step="0.1"
                            value={keForm.kg}
                            onChange={(e) =>
                              setKeForm({ ...keForm, kg: e.target.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Desi</Label>
                          <Input
                            type="number"
                            min="1"
                            value={keForm.desi}
                            onChange={(e) =>
                              setKeForm({ ...keForm, desi: e.target.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <Label>Not</Label>
                      <Input
                        value={keForm.note}
                        onChange={(e) =>
                          setKeForm({ ...keForm, note: e.target.value })
                        }
                        placeholder="Sipariş notu..."
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <h6 className="mb-3 text-muted">Alıcı Bilgileri</h6>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Ad *</Label>
                          <Input
                            value={keForm.name}
                            onChange={(e) =>
                              setKeForm({ ...keForm, name: e.target.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Soyad *</Label>
                          <Input
                            value={keForm.surname}
                            onChange={(e) =>
                              setKeForm({ ...keForm, surname: e.target.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <Label>Telefon *</Label>
                      <Input
                        value={keForm.phone}
                        onChange={(e) =>
                          setKeForm({ ...keForm, phone: e.target.value })
                        }
                        placeholder="5XXXXXXXXX"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>E-posta</Label>
                      <Input
                        type="email"
                        value={keForm.email}
                        onChange={(e) =>
                          setKeForm({ ...keForm, email: e.target.value })
                        }
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Şehir *</Label>
                      <Input
                        value={keForm.city}
                        onChange={(e) =>
                          setKeForm({ ...keForm, city: e.target.value })
                        }
                        placeholder="ISTANBUL"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>İlçe</Label>
                      <Input
                        value={keForm.district}
                        onChange={(e) =>
                          setKeForm({ ...keForm, district: e.target.value })
                        }
                        placeholder="KADIKÖY"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Posta Kodu</Label>
                      <Input
                        value={keForm.postcode}
                        onChange={(e) =>
                          setKeForm({ ...keForm, postcode: e.target.value })
                        }
                        placeholder="34000"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Adres *</Label>
                      <Input
                        type="textarea"
                        rows={2}
                        value={keForm.address}
                        onChange={(e) =>
                          setKeForm({ ...keForm, address: e.target.value })
                        }
                        placeholder="Açık adres..."
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </>
          )}

          {/* ShipEntegra Formu */}
          {provider === "se" && (
            <Row>
              <Col md={6}>
                <h6 className="mb-3 text-muted">Kargo Firması</h6>
                <FormGroup>
                  <Label>Taşıyıcı Seç *</Label>
                  {carriersLoading ? (
                    <div className="text-center py-2">
                      <Spinner size="sm" /> Yükleniyor...
                    </div>
                  ) : (
                    <Input
                      type="select"
                      value={seForm.carrierId}
                      onChange={(e) =>
                        setSeForm({ ...seForm, carrierId: e.target.value })
                      }
                    >
                      <option value="">-- Kargo Firması Seçin --</option>
                      {carriers.map((c, i) => (
                        <option
                          key={i}
                          value={c.id || c.Id || c.carrierId || c.CarrierId}
                        >
                          {c.name || c.Name || c.carrierName || c.CarrierName || `Firma ${i + 1}`}
                        </option>
                      ))}
                    </Input>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label>Ödeme Tipi</Label>
                  <Input
                    type="select"
                    value={seForm.paymentType}
                    onChange={(e) =>
                      setSeForm({ ...seForm, paymentType: e.target.value })
                    }
                  >
                    <option value="0">Gönderici Öder</option>
                    <option value="1">Alıcı Öder (Kapıda Ödeme)</option>
                  </Input>
                </FormGroup>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Ağırlık (kg)</Label>
                      <Input
                        type="number"
                        min="0.1"
                        step="0.1"
                        value={seForm.weight}
                        onChange={(e) =>
                          setSeForm({ ...seForm, weight: e.target.value })
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Desi</Label>
                      <Input
                        type="number"
                        min="1"
                        step="1"
                        value={seForm.desi}
                        onChange={(e) =>
                          setSeForm({ ...seForm, desi: e.target.value })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup>
                  <Label>Açıklama</Label>
                  <Input
                    value={seForm.description}
                    onChange={(e) =>
                      setSeForm({ ...seForm, description: e.target.value })
                    }
                    placeholder="Paket içeriği"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <h6 className="mb-3 text-muted">Alıcı Bilgileri</h6>
                <FormGroup>
                  <Label>Ad Soyad *</Label>
                  <Input
                    value={seForm.receiverName}
                    onChange={(e) =>
                      setSeForm({ ...seForm, receiverName: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Telefon *</Label>
                  <Input
                    value={seForm.receiverPhone}
                    onChange={(e) =>
                      setSeForm({ ...seForm, receiverPhone: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Şehir *</Label>
                  <Input
                    value={seForm.receiverCity}
                    onChange={(e) =>
                      setSeForm({ ...seForm, receiverCity: e.target.value })
                    }
                    placeholder="İstanbul"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>İlçe</Label>
                  <Input
                    value={seForm.receiverDistrict}
                    onChange={(e) =>
                      setSeForm({ ...seForm, receiverDistrict: e.target.value })
                    }
                    placeholder="Kadıköy"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Posta Kodu</Label>
                  <Input
                    value={seForm.receiverPostalCode}
                    onChange={(e) =>
                      setSeForm({ ...seForm, receiverPostalCode: e.target.value })
                    }
                    placeholder="34000"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Adres *</Label>
                  <Input
                    type="textarea"
                    rows={2}
                    value={seForm.receiverAddress}
                    onChange={(e) =>
                      setSeForm({ ...seForm, receiverAddress: e.target.value })
                    }
                    placeholder="Açık adres..."
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            outline
            onClick={() => setCreateModal(false)}
            disabled={shipmentLoading}
          >
            İptal
          </Button>
          <Button
            color="success"
            onClick={handleCreateShipment}
            disabled={shipmentLoading}
          >
            {shipmentLoading ? (
              <>
                <Spinner size="sm" className="me-1" />
                Oluşturuluyor...
              </>
            ) : (
              <>
                <i className="bx bx-package me-1" />
                Kargoyu Oluştur
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Takip Modal */}
      <Modal isOpen={trackModal} toggle={() => setTrackModal(false)} centered>
        <ModalHeader toggle={() => setTrackModal(false)}>
          <i className="bx bx-map-pin me-2 text-info" />
          Kargo Takip — {selectedTeslimat?.KARGO_TAKIP_NO || selectedTeslimat?.KARGO_REFERANS_ID}
        </ModalHeader>
        {selectedTeslimat?.KARGO_TAKIP_LINKI && (
          <div className="px-4 pt-3">
            <a
              href={selectedTeslimat.KARGO_TAKIP_LINKI}
              target="_blank"
              rel="noreferrer"
              className="btn btn-info btn-sm w-100"
            >
              <i className="bx bx-link-external me-1" />
              Kargo Firması Takip Sayfasını Aç
            </a>
          </div>
        )}
        <ModalBody>
          {trackLoading ? (
            <div className="text-center py-4">
              <Spinner color="info" />
            </div>
          ) : trackData ? (
            <div>
              {/* KargoEntegratör takip */}
              {trackData._source === "ke" && (
                <>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">Durum</span>
                      <Badge color="primary">{trackData.status || "-"}</Badge>
                    </div>
                    {trackData.cargo_company?.title && (
                      <div className="d-flex justify-content-between mb-1">
                        <span className="text-muted">Kargo Firması</span>
                        <span>{trackData.cargo_company.title}</span>
                      </div>
                    )}
                    {trackData.barcode && (
                      <div className="d-flex justify-content-between mb-1">
                        <span className="text-muted">Barkod</span>
                        <span className="font-monospace">{trackData.barcode}</span>
                      </div>
                    )}
                    {trackData.tracking_number && (
                      <div className="d-flex justify-content-between mb-1">
                        <span className="text-muted">Takip No</span>
                        <span className="font-monospace">{trackData.tracking_number}</span>
                      </div>
                    )}
                  </div>
                  {Array.isArray(trackData.steps) && trackData.steps.length > 0 && (
                    <div>
                      <h6 className="mb-2">Kargo Geçmişi</h6>
                      <div className="timeline-list">
                        {trackData.steps.map((step, i) => (
                          <div
                            key={i}
                            className="d-flex gap-2 mb-2 pb-2 border-bottom"
                          >
                            <i className="bx bx-radio-circle-marked text-primary mt-1" />
                            <div>
                              <div className="fw-medium">{step.message || step.status}</div>
                              <small className="text-muted">
                                {step.created_at
                                  ? new Date(step.created_at).toLocaleString("tr-TR")
                                  : ""}
                              </small>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
              {/* ShipEntegra takip */}
              {trackData._source === "se" && (
                <>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">Durum</span>
                      <Badge color="primary">
                        {BOSTA_DURUM_MAP[trackData.status] ||
                          trackData.status ||
                          trackData.currentStatus ||
                          "-"}
                      </Badge>
                    </div>
                    {trackData.carrierName && (
                      <div className="d-flex justify-content-between mb-1">
                        <span className="text-muted">Kargo Firması</span>
                        <span>{trackData.carrierName}</span>
                      </div>
                    )}
                  </div>
                  {Array.isArray(trackData.events || trackData.history) && (
                    <div>
                      <h6 className="mb-2">Kargo Geçmişi</h6>
                      <div className="timeline-list">
                        {(trackData.events || trackData.history).map((ev, i) => (
                          <div
                            key={i}
                            className="d-flex gap-2 mb-2 pb-2 border-bottom"
                          >
                            <i className="bx bx-radio-circle-marked text-primary mt-1" />
                            <div>
                              <div className="fw-medium">
                                {ev.description || ev.status || ev.message}
                              </div>
                              <small className="text-muted">
                                {ev.location || ev.city || ""}{" "}
                                {ev.date || ev.timestamp
                                  ? new Date(ev.date || ev.timestamp).toLocaleString("tr-TR")
                                  : ""}
                              </small>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          ) : (
            <p className="text-muted text-center">Takip bilgisi bulunamadı.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setTrackModal(false)}>
            Kapat
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default TeslimatYonetimi;
